import script from "./video-bg-remove.vue?vue&type=script&setup=true&lang=js"
export * from "./video-bg-remove.vue?vue&type=script&setup=true&lang=js"

import "./video-bg-remove.vue?vue&type=style&index=0&id=206d7cc6&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206d7cc6"]])

export default __exports__